import { getUrlSearchParameter } from '../../../../shared/helpers'

export const EACH_FIVE_SECONDS = 5000
export const EACH_FIFTEEN_SECONDS = 15000
export const TWO_HUNDRED_FORTY_ATTEMPTS = 240
export const TWELVE_ATTEMPTS = 12
export const DEVICE_KEY = 'deviceId-ga'
export const UID_KEY = 'uID-ga'

export const setTimer = (
  callback: () => void,
  wait: number,
  times: number,
  nextCallback: () => void
): NodeJS.Timeout => {
  let counter = 0
  const intervalId = setInterval(() => {
    if (counter === times) {
      nextCallback()
    }
    if (counter === times) {
      clearInterval(intervalId)
      return
    }

    try {
      callback()
    } catch (e) {
      counter = 0
      throw e.toString()
    }
    counter++
  }, wait)
  return intervalId
}

export const getActivationRedirectLink = (locationSearch: string) => {
  const redirectValue = getUrlSearchParameter(locationSearch, 'redirect')
  return `/activate${redirectValue ? `?redirect=${redirectValue}` : ''}`
}
